import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import includes from "lodash/includes";
import ResearchSnapshotRow from "./ResearchSnapshotRow";

const StyledPlainGrid = styled("div")({
    margin: "10px 0px 5px 0px",
});

const StyledTableContainer = styled("div")({
    overflowX: "auto",
    width: "100%",
});

const StyledCellHeader = styled(TableCell)({
    backgroundColor: "#257692",
    color: "#ffffff",
    whiteSpace: "nowrap",
});

const ResearchSnapshotTable = (props) => {
    const { snapshots, role, editResponse } = props;
    const columns = [
        { header: "Notes", field: "notes", group: "notes", editable: false },
        { header: "Year", field: "year", group: "default", editable: false },
        { header: "Quarter", field: "quarter", group: "default", editable: false },
        { header: "Status", field: "buildingStatus", group: "default", editable: false },
        { header: "Class", field: "buildingClass", group: "default", editable: false },
        { header: "Sub-Type", field: "subtype", group: "specialtyType", editable: false },
        { header: "Market", field: "market", group: "default", editable: false },
        { header: "Submarket", field: "submarket", group: "default", editable: false },
        { header: "Micro Market", field: "micromarket", group: "default", editable: false },
        { header: "RBA (SF)", field: "totalBuildingSf", group: "sqFt", editable: true },
        { header: "Avail %", field: "availablePercentage", group: "percentage", editable: true },
        { header: "Total Avail (SF)", field: "totalSfAvailable", group: "sqFt", editable: true },
        { header: "Direct Avail (SF)", field: "directSfAvailable", group: "sqFt", editable: true },
        { header: "Sublease Avail (SF)", field: "slAvailable", group: "sqFt", editable: true },
        { header: "Vacant %", field: "vacantPercentage", group: "percentage", editable: true },
        { header: "Total Vacant (SF)", field: "totalVacantSf", group: "sqFt", editable: true },
        { header: "Direct Vacant (SF)", field: "directVacant", group: "sqFt", editable: true },
        { header: "Sublease Vacant (SF)", field: "subleaseVacant", group: "sqFt", editable: true },
        { header: "Lease Rate", field: "leaseRate", group: "lease", editable: true },
        { header: "Net Absorption (SF)", field: "netAbsorption", group: "sqFt", editable: true },
        { header: "Edit", field: "edit", group: "edit", editable: false },
    ];

    return (
        <StyledPlainGrid>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
                <StyledTableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columns.map((column, i) => {
                                    const { header, field } = column;
                                    return field === "edit" &&
                                        !includes(["research", "researchAdmin", "dataAdmin"], role) ? null : (
                                        <StyledCellHeader
                                            key={column + i}
                                            align={"center"}
                                            style={{ minWidth: "fit-content" }}
                                        >
                                            {column.case === "sqFt" ? `${header} (SF)` : header}
                                        </StyledCellHeader>
                                    );
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {snapshots.map((snapshot) => (
                                <ResearchSnapshotRow
                                    key={snapshot.researchSnapshotKey}
                                    role={role}
                                    snapshot={snapshot}
                                    columns={columns}
                                    editResponse={editResponse}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </StyledTableContainer>
            </Paper>
        </StyledPlainGrid>
    );
};

export default ResearchSnapshotTable;
